import { hrApiClient } from '@/lib/api/clients';

export async function trackStatistic(
  key: string,
  itemId?: number | string,
  userId?: number,
): Promise<void> {
  await hrApiClient.get('/statistic', {
    params: {
      key,
      ...(itemId != null ? { itemId } : {}),
      ...(userId != null ? { userId } : {}),
    },
  });
}
